import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('@/views/home')
        },
        {
            path: '/cases',
            component: () => import('@/views/cases'),
            children: [
                {
                    path: 'forum',
                    name: 'Forum',
                    component: () => import('@/views/cases/Forum.vue')
                },
                {
                    path: 'exhibitions',
                    name: 'Exhibitions',
                    component: () => import('@/views/cases/Exhibitions.vue')
                },
                {
                    path: 'training',
                    name: 'Training',
                    component: () => import('@/views/cases/Training.vue')
                },
                {
                    path: 'oneonone',
                    name: 'Oneonone',
                    component: () => import('@/views/cases/OneOnOneService.vue')
                },
                {
                    path: 'roadshow',
                    name: 'Roadshow',
                    component: () => import('@/views/cases/Roadshow.vue')
                },
                {
                    path: 'anli/:id',
                    name: 'CaseDetail',
                    component: () => import('@/views/cases/CaseDetail.vue')
                },
                {
                    path: 'info',
                    name: 'CasesIndexInfo',
                    component: () => import('@/views/cases/Cases.vue')
                },
                {
                    path: '',
                    redirect: '/cases/info' // 或指向某个默认子组件
                }
            ]
        },
        {
            path: '/member',
            name: 'MemberIndex',
            component: () => import('@/views/member')
        },
        {
            path: '/aboutus',
            name: 'AboutusIndex',
            component: () => import('@/views/aboutus')
        },
        // {
        //     path: '/user',
        //     name: 'User',
        //     component: () => import('@/views/user') // 用户中心首页
        // },
        // {
        //     path: '/user/detail',
        //     name: 'UserDetail',
        //     component: () => import('@/views/user/UserDetail') // 复杂页面，对应 UserDetail/index.vue
        // },
        {
            path: '*', // 匹配所有未定义路由
            name: 'PageNotFound',
            component: () => import('@/views/common/PageNotFound') // 404 页面
        }
    ]
})